define('gsu-popover/gsu-popover',['require','lib/auth/auth','api-access','knockout','lib/progress-component/percent-complete','lib/check-first-visit','text!./gsu-popover.html'],function (require) {
    var auth = require('lib/auth/auth');
    var userApi = require('api-access').user;
    var self = this;
    var ko = require('knockout');
    var getPercentCompleted = require('lib/progress-component/percent-complete');
    var checkFirstVisit = require('lib/check-first-visit');

    self.countSteps = ko.observable();

    self.hide = function () { $('#menu-gsu').popover('hide') };

    self.gsuPopoverShown = function () { userApi.updateSettings({isGSUPopoverShown: true}) };

    self.mouseUpHandler = function (event) {
        var popOver = $('#menu-gsu + .popover');

        if (!popOver.is(event.target) && popOver.has(event.target).length === 0) {
            self.hide();
        }
    };

    function show() {
        if (auth.getToken()) {
            $.when(
                getPercentCompleted(),
                userApi.settings(),
                checkFirstVisit.check()
            ).then(function (percent, settings, isFirstLogin) {
                var userSettings = settings[0];
                self.countSteps('You\'ve completed ' + percent / 20 + ' of 5 steps');

                var isGSUEnabled = userSettings.isGSUEnabled;
                var isGsuPopoverShown = userSettings.isGSUPopoverShown;
                var hasCompletedGSU = userSettings.hasCompletedGSU;
                var gsuTab = $('#menu-gsu');
                var TIME_TO_CLOSE = 10000;

                if (!isGsuPopoverShown && !hasCompletedGSU && !isFirstLogin && isGSUEnabled) {
                    gsuTab.popover({
                        trigger: 'manual',
                        placement: 'bottom',
                        html: true,
                        template: require('text!./gsu-popover.html'),
                        content: function () { return $('#gsu-popover-content').html() }
                    });

                    gsuTab.on('shown.bs.popover', function () {
                        $(document).bind('mouseup', self.mouseUpHandler);
                    });

                    gsuTab.on('hidden.bs.popover', function () {
                        $(document).unbind('mouseup', self.mouseUpHandler);
                    });

                    gsuTab.popover('show');
                    setTimeout(function () { self.hide() }, TIME_TO_CLOSE);

                    self.gsuPopoverShown();

                    $('#gsu-popover-close-btn').click(function (event) {
                        self.hide();
                        // Need the stopPropogation to close the popover and not open the GSU
                        // In other cases (Click on the popover body), the popover should close and GSU should open up
                        event.stopPropagation();
                    });

                    $('#gsu-popover').click(function () {
                        self.hide();
                    });
                }
            });
        }
    }
    return {
        show: show
    };
});

